export const transformCreditCardEncryptedModel = _ref => {
  let {
    cardNumber,
    expirationMonth,
    expirationYear,
    cvc
  } = _ref;
  return {
    number: cardNumber,
    expiration_month: expirationMonth,
    expiration_year: expirationYear,
    security_code: cvc
  };
};